import dayjs from 'dayjs'
import styles from '../styles/components/iconText.module.scss'
import { EventDateDto } from '../types/EventDateDto'
type IconTextProps = {
  icon?: string
  label?: string
  value?: string | number | EventDateDto[]
}

const IconText: React.FC<IconTextProps> = ({ icon, label, value }) => {
  return (
    <div className={styles.iconTextRow}>
      <span className={`e-icons ${icon} ${styles.icon}`}></span>
      <div className={styles.textContainer}>
        <span className={styles.label}>{label}</span>
        <span>
          {typeof value === 'object'
            ? value?.map(function (item, index) {
                return (
                  <div key={index} className={styles.dateWrapper}>
                    <span className={styles.date}>{dayjs(item.dateTimeStart).format('DD.MM.YYYY')}</span>
                    <span>{dayjs(item.dateTimeStart).format('HH:mm')}</span> - <span>{dayjs(item.dateTimeEnd).format('HH:mm')}</span> Uhr
                  </div>
                )
              })
            : value}
        </span>
      </div>
    </div>
  )
}

export default IconText
